import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('h5', {
    staticClass: "mt-0 headline-with-icon"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.packetsReceivedTimeFrame')) + "\n         \n        "), _c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_vm.deviceData.properties && _vm.deviceData.properties.enable_statistics ? _c(VIcon, _vm._g({
          attrs: {
            "color": _vm.color,
            "dark": "",
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.showDeviceStatistics = !_vm.showDeviceStatistics;
            }
          }
        }, on), [_vm._v("\n              fal fa-chart-bar\n            ")]) : _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "dark": "",
            "small": ""
          }
        }, [_vm._v("fal fa-times")])];
      }
    }])
  }, [_c('span', [_vm._v("\n            " + _vm._s(!_vm.deviceData.properties.enable_statistics ? _vm.$i18n_t('NiotaClassic.Devices.details.enableStatisticsHint') : _vm.$i18n_t('NiotaClassic.Devices.details.showHideStatistics')) + "\n          ")])])], 1), _vm.deviceData.properties && _vm.deviceData.properties.enable_statistics && _vm.validStatistics && _vm.showDeviceStatistics ? _c('div', [_vm.showDeviceStatistics ? _c('p', [_c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-calendar-exclamation")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.totalPackets')) + " (" + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.latest')) + "\n          "), _c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VIcon, _vm._g({
          attrs: {
            "dark": "",
            "small": "",
            "color": _vm.color
          }
        }, on), [_vm._v("fal fa-info-circle")])];
      }
    }], null, false, 1300611995)
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.latestTotalDef')) + "\n          ")]), _vm._v("\n          /" + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.previous')) + "\n          "), _c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VIcon, _vm._g({
          attrs: {
            "dark": "",
            "small": "",
            "color": _vm.color
          }
        }, on), [_vm._v("fal fa-info-circle")])];
      }
    }], null, false, 1300611995)
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.previosTotalDef')) + "\n          ")]), _vm._v("\n          ):\n          "), _c('b', [_vm._v("\n            " + _vm._s(_vm.periodStatistics.sum + _vm.newPacketsbyWS) + " /\n            " + _vm._s(_vm.periodOlderStatistics.valid ? _vm.periodOlderStatistics.sum : _vm.$i18n_t('Common.notAvailable')) + "\n          ")]), _vm._v("\n          - " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.increaseRatio')) + "\n          "), _c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VIcon, _vm._g({
          attrs: {
            "dark": "",
            "small": "",
            "color": _vm.color
          }
        }, on), [_vm._v("fal fa-info-circle")])];
      }
    }], null, false, 1300611995)
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.increaseRatioDef')) + "\n          ")]), _vm._v("\n          :\n          "), _c('span', {
    style: _vm.packetsIncreaseRatio.increase ? 'color:#09b609' : 'color:Tomato'
  }, [_c('b', [_vm._v(_vm._s(_vm.packetsIncreaseRatio.value) + "%")]), _vm.packetsIncreaseRatio.value !== _vm.$i18n_t('Common.notAvailable') || _vm.packetsIncreaseRatio.value !== 0 ? _c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.color
    }
  }, [_vm._v("\n              fal fa-arrow-circle-" + _vm._s(_vm.packetsIncreaseRatio.increase ? 'up' : 'down') + "\n            ")]) : _c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-minus-circle")])], 1)], 1) : _vm._e(), _c('p', [_c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-clock")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.sends')) + "\n          "), _c('b', [_vm._v("\n            " + _vm._s(_vm.periodStatistics.rate.value !== 1 ? _vm.$i18n_t('NiotaClassic.Devices.details.every') + ' ' + _vm.periodStatistics.rate.value + _vm.periodStatistics.rate.unit : _vm.$i18n_t('NiotaClassic.Devices.details.always')) + "\n          ")]), _vm._v("\n          (" + _vm._s(_vm.sendingRate) + "% " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.ofTheTimeFrame')) + "\n          "), _c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VIcon, _vm._g({
          attrs: {
            "dark": "",
            "small": "",
            "color": _vm.color
          }
        }, on), [_vm._v("fal fa-info-circle")])];
      }
    }], null, false, 1300611995)
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.sendingRateDef')) + "\n          ")]), _vm._v("\n          )\n        ")], 1), _c('p', [_c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-analytics")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.chartLabelsHint')) + ":\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.latest')) + "\n          "), _c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VIcon, _vm._g({
          attrs: {
            "dark": "",
            "small": "",
            "color": _vm.color
          }
        }, on), [_vm._v("fal fa-info-circle")])];
      }
    }], null, false, 1300611995)
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.latestAverageDef')) + "\n          ")]), _vm._v("\n          / " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.previous')) + "\n          "), _c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VIcon, _vm._g({
          attrs: {
            "dark": "",
            "small": "",
            "color": _vm.color
          }
        }, on), [_vm._v("fal fa-info-circle")])];
      }
    }], null, false, 1300611995)
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.previousAverageDef')) + "\n          ")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.average')) + ", " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.threshold')) + "\n          "), _c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VIcon, _vm._g({
          attrs: {
            "dark": "",
            "small": "",
            "color": _vm.color
          }
        }, on), [_vm._v("fal fa-info-circle")])];
      }
    }], null, false, 1300611995)
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.nominalThresholdPacketDef')) + "\n          ")])], 1)]) : _vm._e(), _vm.deviceData.properties && _vm.deviceData.properties.enable_statistics && !_vm.validStatistics && _vm.showDeviceStatistics ? _c('div', [_c('p', [_c(VIcon, {
    attrs: {
      "dark": "",
      "small": "",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-database")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.notEnoughData')) + "\n        ")], 1)]) : _vm._e()]), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.timeFrames,
      "item-text": "name",
      "return-object": "",
      "solo": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('select-metrics-length', _vm.selectedTimeFrame);
      }
    },
    model: {
      value: _vm.selectedTimeFrame,
      callback: function ($$v) {
        _vm.selectedTimeFrame = $$v;
      },
      expression: "selectedTimeFrame"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };